var map = {
	"./A2A-introduce.svg": 90440,
	"./accountant-introduce.svg": 73833,
	"./api.svg": 86136,
	"./apired.svg": 92062,
	"./customer-introduce.svg": 63027,
	"./customer.svg": 61378,
	"./customerred.svg": 72610,
	"./gray-A2A.svg": 22849,
	"./gray-accountant.svg": 68747,
	"./gray-customer.svg": 70722,
	"./gray-kerdar.svg": 12474,
	"./gray-requestMoney.svg": 38125,
	"./gray-settlement_batch.svg": 23462,
	"./gray-subscription.svg": 49854,
	"./inquiry-introduce.svg": 88078,
	"./invoice.svg": 31181,
	"./invoiceAndCustomer.svg": 77483,
	"./invoicered.svg": 3256,
	"./ipg-introduce.svg": 41572,
	"./ipg.svg": 32607,
	"./ipgGreen.svg": 86810,
	"./ipgred.svg": 62165,
	"./kerdar-introduce.svg": 16192,
	"./log.svg": 6809,
	"./log_Big.svg": 52695,
	"./logred.svg": 62694,
	"./miando.svg": 70767,
	"./p2p.svg": 86100,
	"./p2pGreen.svg": 2541,
	"./p2pYellow.svg": 52152,
	"./p2pred.svg": 55312,
	"./requestMoney-introduce.svg": 59208,
	"./requestMoney.svg": 89950,
	"./requestMoneyGreen.svg": 61023,
	"./requestMoneyred.svg": 12117,
	"./settlement_batch-introduce.svg": 38780,
	"./settlement_batch.svg": 90610,
	"./subscription-introduce.svg": 95434,
	"./subscription.svg": 95376,
	"./subscriptionGreen.svg": 10881,
	"./subscriptionred.svg": 42512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59930;